import {Observable} from 'rxjs';
import {Parameter} from '../common/parameter';
import { Binary } from '@angular/compiler';

export interface BloodParameter extends Parameter {
    searchTerm: number;
    orderBy: string;

}

export interface Blood {
    id?: any;  
    name:string;    
    parameters?: BloodParameter[];
    links?: any;
}

export abstract class BloodData {
   
    abstract list(url: string): Observable<Blood[]>;
    abstract create(url: string, data: Blood): Observable<Blood[]>;
    abstract update(url: string, data: Blood): Observable<Blood>;
    abstract delete(url: string): Observable<any>;
}